import type React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { useField } from "formik";
import { RESEARCH } from "commons/constants/env";

interface FieldOptions {
  allowNegative?: boolean | string;
  disabled?: boolean;
}

export interface TextFieldFormikProps
  extends Omit<TextFieldProps, 'name' | 'value' | 'onChange' | 'onBlur' | 'error'> {
  name: string;
  status?: boolean;
  options?: FieldOptions;
}

const TextFieldFormik = ({ name, helperText, status, options, ...props }: TextFieldFormikProps) => {
  const [field, meta, helpers] = useField(name);

  /**
   * Handle input values and save it to Formik state
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    const numericValue = Number(value);
    const negativeAllowed = options?.allowNegative === true || options?.allowNegative === 'true';

    if (!negativeAllowed && numericValue < 0 && RESEARCH !== 'REFSAL') return;

    // if (!isNaN(numericValue)) {
    //   value = numericValue.toLocaleString('pl-PL');
    // }

    helpers.setValue(value);
    // field.onChange(e);
  }

  const handleWheelCapture = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };

  return (
    <TextField
      name={field.name}
      variant="outlined"
      value={field.value || ''}
      disabled={status || options?.disabled}
      onChange={handleChange}
      onBlur={field.onBlur}
      onWheelCapture={handleWheelCapture}
      error={meta.touched && Boolean(meta.error)}
      helperText={(meta.touched && meta.error) || helperText}
      autoComplete='off'
      {...props}
    />
  );
};

export default TextFieldFormik;